var isSupportDownload = function (ele) {
  return 'download' in ele;
};
var wos;
var wosObj = {};     //key:file_name value:lastTaskId
var fileHandler = function () { };
fileHandler.prototype.init = function (options) {
  this.WosInfo = options;
};
fileHandler.prototype.upload = function (data, successCb, failCb, progressCb) {
  var wos_file_name = data.wos_file_name ? data.wos_file_name : '';
  var bucket = data.bucket ? data.bucket : '';
  var emptyfun = function () {
  };
  typeof progressCb !== 'function' ? progressCb = emptyfun : typeof failCb !== 'function' ? failCb = emptyfun : typeof successCb !== 'function' ? successCb = emptyfun : null;
  wos = new WosSys({
    appid: this.WosInfo.WOS_APP_ID,// APPID 必填参数
    bucket: data.bucket,//bucketName 必填参数
    wosurl: this.WosInfo.WOS_URL,//wos的url 必填参数
    getAppSign: function (callback) {//获取签名 必填参数
      callback(encodeURIComponent(data.wos_token));
    }
  });
  // 秒传接口
  var alias = data.file.name ? data.file.name : null;
  var taskReady = function (taskId) {
    wosObj[wos_file_name] = taskId;
  };
  var params = {
    bucketName: bucket,               // 文件bucket
    remotePath: wos_file_name,           // 文件路径
    ttl: data.wos_file_expire,                         // 文件过期时间
    insertOnly: this.WosInfo.IS_COVER,           // 同名文件是否覆盖上传 0:覆盖  1：不覆盖
    taskReady: taskReady,    // 当前上传文件的任务id
    optSliceSize:'1M' ,       //大文件上传的分片大小，默认1M，支持1,2,3,4M,小文件该字段为0，不受该值影响.
    alias: alias,                     //文件别名，默认不设置，如果设置，下载时通过http头中Content-Disposition字段返回
    onUploadProgress:progressCb,    // 文件上传失败回调
    onUploadSuccess:successCb,    // 文件上传成功回调
    onUploadError: failCb       // 文件上传中回调
  };
  wos.upload(data.file, params);
};
fileHandler.prototype.createThumbnail = function (file, cb) {
  var windowURL = window.URL || window.webkitURL;
  if (!windowURL) {
    return cb(null);
  }
  var videoURL;
  //if(file && typeof file != 'string'){
  videoURL = windowURL.createObjectURL(file);
  // }else if(file && file.length && file.indexOf('http') > -1 && file.indexOf('https') > -1){
  //   videoURL = file;
  // }
  var videoEle = document.createElement('video');
  videoEle.setAttribute('class', 'preloadVideo');
  videoEle.setAttribute('src', videoURL);
  videoEle.setAttribute('controls', 'controls');
  videoEle.setAttribute("crossOrigin", 'Anonymous');
  videoEle.setAttribute('visibility', 'hidden');
  videoEle.style.visibility = 'hidden';
  videoEle.muted = true;
  document.body.appendChild(videoEle);
  var playPromise = videoEle.play();
  var videoImgReady = false;
  var createVideoImg = function () {
    videoEle.pause();
    var scale = 1,
      canvas = document.createElement("canvas"),
      canvasFill = canvas.getContext('2d'),
      video = document.getElementsByClassName('preloadVideo')[0];
    canvas.width = video.videoWidth * scale;
    canvas.height = video.videoHeight * scale;
    canvasFill.drawImage(video, 0, 0, canvas.width, canvas.height);
    document.body.removeChild(videoEle);
    videoImgReady = true;
    return {
      data: canvas.toDataURL('image/jpeg'),
      width: canvas.width,
      height: canvas.height,
      duration: video.duration
    };
  };
  if(playPromise && typeof playPromise.then == 'function'){
    playPromise.then(function(){
      if(!videoImgReady){
        cb(createVideoImg());
      }
    });
  }
  setTimeout(function () {
    if(!videoImgReady){
      cb(createVideoImg());
    }
  }, 500);
};
fileHandler.prototype.downloadFromURL = function (href, title) {
  var aLink = document.createElement('a');
  if (isSupportDownload(aLink)) {
    aLink.setAttribute('download', title);
  }
  document.body.appendChild(aLink);
  aLink.setAttribute('href', href);
  if (title && typeof title.split == 'function') {
    var splitName = title.indexOf('.mp4') > 0 ? '.mp4' : title.indexOf('.mov') > 0 ? '.mov' : '.txt';
    var titleSplits = title.split(splitName);
    if (titleSplits && titleSplits.length > 1 && titleSplits[titleSplits.length - 1] == "") {
      aLink.setAttribute('target', '_blank');
    }
  }
  aLink.style.display = 'none';
  aLink.click();
  document.body.removeChild(aLink);
};
fileHandler.prototype.downloadFromBlob = function (content, title) {
  var windowURL = window.URL || window.webkitURL;
  var blob = new Blob([content]);
  var href = windowURL.createObjectURL(blob);
  this.downloadFromURL(href, title);
};
fileHandler.prototype.cancelUpload = function (file_name) {
  // 取消上传文件
  var lastTaskId = wosObj[file_name];
  wos && wos.cancelUpload(lastTaskId);
};

module.exports = new fileHandler();
